"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MeterReadingWizardStepEnum = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _meterReading = require("../../redux/meterReading");
var _MeterReadingForm = _interopRequireDefault(require("../../components/MeterRead/Anonym/MeterReadingForm/MeterReadingForm"));
var _MeterCounter = _interopRequireDefault(require("../../components/MeterRead/Anonym/MeterReadingGeneric/MeterCounter"));
var _MeterInformationBox = _interopRequireDefault(require("../../components/MeterRead/Anonym/MeterReadingGeneric/MeterInformationBox"));
var _MeterReadingGeneric = _interopRequireDefault(require("../../components/MeterRead/Anonym/MeterReadingGeneric/MeterReadingGeneric"));
var _NoRegisterError = _interopRequireDefault(require("../../components/MeterRead/Anonym/NoRegisterError/NoRegisterError"));
var _MeterReadThanks = _interopRequireDefault(require("../../components/MeterRead/Anonym/MeterReadThanks/MeterReadThanks"));
var _MeterReadingInfoMessageDisplay = _interopRequireDefault(require("../../components/MeterRead/Core/MeterReadInfoMessageDisplay/MeterReadingInfoMessageDisplay"));
var _meterReadingFormHelper = require("../../components/MeterRead/Anonym/MeterReadingForm/meterReadingFormHelper");
var _SessionHandler = _interopRequireWildcard(require("../../../utils/SessionHandler"));
var _meterReadingMainActions = require("../../actions/meterReading/meterReadingMainActions");
var _StepComponent = _interopRequireDefault(require("../../components/StepComponent/StepComponent"));
var _MeterReadingEmailFeedback = _interopRequireWildcard(require("../../components/MeterRead/Anonym/MeterReadingEmailFeedback/MeterReadingEmailFeedback"));
var _MeterReadingRegister = _interopRequireDefault(require("../../components/MeterRead/Anonym/MeterReadingRegister/MeterReadingRegister"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MeterReadingWizardStepEnum = exports.MeterReadingWizardStepEnum = {
  READING: 'reading',
  EMAIL_FEEDBACK: 'email-feedback',
  REGISTER: 'register',
  FINISHED: 'finished'
};
var MeterReadingPage = function MeterReadingPage(props) {
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    lockedMeterCount = _useState2[0],
    setLockedMeterCount = _useState2[1];
  var _useState3 = (0, _react.useState)({
      feedbackEmail: '',
      emailFeedbackStatus: _MeterReadingEmailFeedback.EmailFeedbackStatusEnum.PENDING,
      okoEmail: ''
    }),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    state = _useState4[0],
    setState = _useState4[1];
  var stringConverter = function stringConverter(str) {
    if (str === 'true') return true;
    return false;
  };
  var canSeeRegister = stringConverter(sessionStorage.getItem('anonymousOkoAllowed'));
  var paginateWithCurrentPageId = function paginateWithCurrentPageId() {
    props.paginate(props.currentPageId);
  };
  (0, _react.useEffect)(function () {
    _SessionHandler.default.userMustBeLoggedIn(_SessionHandler.loginTypes.anonym);
    props.loadMeterReadingData(0);
  }, []);
  var generateStepLabels = function generateStepLabels() {
    var stepLabelsArray = [{
      label: props.stepComponent.meterValueLabel,
      step: MeterReadingWizardStepEnum.READING
    }, {
      label: props.stepComponent.emailConfirm,
      step: MeterReadingWizardStepEnum.EMAIL_FEEDBACK
    }, {
      label: props.stepComponent.register,
      step: MeterReadingWizardStepEnum.REGISTER
    }, {
      label: props.stepComponent.done,
      step: MeterReadingWizardStepEnum.FINISHED
    }];
    if (!canSeeRegister) stepLabelsArray.splice(2, 1);
    return stepLabelsArray;
  };
  if (props.loading) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "row",
      key: "0"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-md-12 col-xs-12 col-sm-12 form-wrapper form-wrapper--has-shadow ano-meter-reading",
      key: "0"
    }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Loader, {
      loading: true,
      fallbackGifSrc: sessionStorage.fallbackLoader
    })));
  }
  if (props.errorHint) {
    var errorArgs = props.errorHint.args;
    if (errorArgs && errorArgs.infoMessages && errorArgs.infoMessages.length) {
      return /*#__PURE__*/_react.default.createElement(_MeterReadingInfoMessageDisplay.default, (0, _extends2.default)({}, props, {
        errorArgs: errorArgs
      }));
    }
  }
  var allMetersLocked = (0, _meterReadingFormHelper.allMetersLockedByImplausibleReadingResults)(props.devices);
  var buildMeterView = function buildMeterView(device, deviceIndex) {
    var _props$devices;
    var meterIsLocked = (0, _meterReading.checkMeterLockedByImplausibleReadingResult)(device);
    if (meterIsLocked) _SessionHandler.default.destroySession(false);
    var isLastMeter = function isLastMeter() {
      return props.devices.length - 1 === Math.abs(props.currentPageId);
    };
    var submitButtonLabel = (0, _meterReadingFormHelper.buildButtonControl)(props.continueButtonText, props.submitButtonText, props.saveAndContinueButtonText, isLastMeter(), (0, _meterReadingFormHelper.isMeterLocked)(props.devices[props.currentPageId]));
    var meterCounter = /*#__PURE__*/_react.default.createElement(_MeterCounter.default, {
      key: "counter, ".concat(deviceIndex),
      meterCounterLabel: props.meterCounterLabel ? props.meterCounterLabel : '',
      index: deviceIndex + 1,
      amount: (_props$devices = props.devices) === null || _props$devices === void 0 ? void 0 : _props$devices.length,
      hasError: props.errorObjects && props.errorObjects.length > 0 && !props.errorObjects.find(function (x) {
        return x.serialNumber === device.serialNumber;
      })
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "col-md-12 col-xs-12 col-sm-12"
    }, props.currentStep === MeterReadingWizardStepEnum.READING && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _meterReadingFormHelper.isMeterLocked)(device) ? /*#__PURE__*/_react.default.createElement("div", {
      className: "ano-meter-reading__hint-text"
    }, !allMetersLocked ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, meterCounter, /*#__PURE__*/_react.default.createElement(_MeterInformationBox.default, {
      energyTypeLabel: props.energyTypeLabel ? props.energyTypeLabel : '',
      deviceNumberLabel: props.deviceNumberLabel ? props.deviceNumberLabel : '',
      lastReadingDateLabel: props.lastReadingDateLabel ? props.lastReadingDateLabel : '',
      newMeterReadingDate: "",
      editButton: false,
      deviceData: device,
      paginate: paginateWithCurrentPageId
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "ano-meter-reading__locked-text"
    }, props.currentMeterLockedText), /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Button, {
      onClick: function onClick() {
        if (isLastMeter()) {
          setLockedMeterCount(lockedMeterCount + 1);
          props.setCurrentStep(MeterReadingWizardStepEnum.EMAIL_FEEDBACK);
        } else {
          setLockedMeterCount(lockedMeterCount + 1);
          props.paginate(props.currentPageId + 1);
        }
      },
      version: props.versions.button,
      qaId: "meter-reading-button-next",
      className: "meter-reading-button-next"
    }, submitButtonLabel)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MeterReadingInfoMessageDisplay.default, (0, _extends2.default)({}, props, {
      allMetersLocked: allMetersLocked,
      allMetersLockedText: props.allMetersLockedText
    })))) : /*#__PURE__*/_react.default.createElement("div", null, meterCounter, /*#__PURE__*/_react.default.createElement(_MeterInformationBox.default, {
      energyTypeLabel: props.energyTypeLabel ? props.energyTypeLabel : '',
      deviceNumberLabel: props.deviceNumberLabel ? props.deviceNumberLabel : '',
      lastReadingDateLabel: props.lastReadingDateLabel ? props.lastReadingDateLabel : '',
      newMeterReadingDate: "",
      editButton: false,
      deviceData: device,
      paginate: paginateWithCurrentPageId
    }), /*#__PURE__*/_react.default.createElement(_MeterReadingForm.default, (0, _extends2.default)({}, props, {
      buttonLabel: submitButtonLabel,
      currentPageId: props.currentPageId,
      paginate: props.paginate,
      loading: props.loading,
      loggedIn: false,
      deviceData: device,
      lastMeter: isLastMeter(),
      setCurrentStep: props.setCurrentStep,
      nextStep: MeterReadingWizardStepEnum.EMAIL_FEEDBACK
    })))), props.currentStep === MeterReadingWizardStepEnum.EMAIL_FEEDBACK && /*#__PURE__*/_react.default.createElement("div", {
      className: "col-md-12 form-wrapper ano-meter-reading"
    }, /*#__PURE__*/_react.default.createElement(_MeterReadingEmailFeedback.default, (0, _extends2.default)({}, props.emailFeedback, {
      emailValidationError: props.emailValidationError,
      emailAddressLabel: props.emailAddressLabel,
      serverErrorMessage: props.serverErrorMessage,
      registerCount: props.devices.length,
      missedMeter: lockedMeterCount,
      amount: props.devices.length,
      onSuccess: function onSuccess(popState, email) {
        if (canSeeRegister) {
          props.setCurrentStep(MeterReadingWizardStepEnum.REGISTER);
        } else {
          props.setCurrentStep(MeterReadingWizardStepEnum.FINISHED);
        }
        setState(_objectSpread(_objectSpread({}, state), {}, {
          emailFeedbackStatus: popState,
          feedbackEmail: email
        }));
      }
    }))), props.currentStep === MeterReadingWizardStepEnum.REGISTER && /*#__PURE__*/_react.default.createElement("div", {
      className: "col-md-12 form-wrapper ano-meter-reading"
    }, /*#__PURE__*/_react.default.createElement(_MeterReadingRegister.default, (0, _extends2.default)({}, props, props.register, {
      emailValidationError: props.emailValidationError,
      serverErrorMessage: props.serverErrorMessage,
      emailAddressLabel: props.emailAddressLabel,
      onNextStep: function onNextStep(registerPage) {
        if (registerPage) {
          window.open(props.registrationButtonLink, '_blank');
        }
        props.setCurrentStep(MeterReadingWizardStepEnum.FINISHED);
      },
      onOkoSuccess: function onOkoSuccess(okoEmail) {
        setState(_objectSpread(_objectSpread({}, state), {}, {
          okoEmail: okoEmail
        }));
        props.setCurrentStep(MeterReadingWizardStepEnum.FINISHED);
      }
    }))), props.currentStep === MeterReadingWizardStepEnum.FINISHED && /*#__PURE__*/_react.default.createElement("div", {
      className: "col-md-12 form-wrapper ano-meter-reading"
    }, /*#__PURE__*/_react.default.createElement(_MeterReadThanks.default, (0, _extends2.default)({}, props.thanksMsg, {
      amount: props.devices.length,
      missedMeter: lockedMeterCount,
      emailFeedbackState: state.emailFeedbackStatus,
      feedbackEmail: state.feedbackEmail,
      okoEmail: state.okoEmail,
      returnUrl: props.anonymousMeterReadingLoginPage
    }))));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.devices && props.devices.length !== 0 ? /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12 col-xs-12 col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: !allMetersLocked ? 'col-md-12 col-xs-12 col-sm-12 form-wrapper form-wrapper--has-shadow ano-meter-reading' : ''
  }, !allMetersLocked && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MeterReadingGeneric.default, {
    genericTitle: props.genericTitle ? props.genericTitle : '',
    contractIdLabel: props.contractIdLabel ? props.contractIdLabel : '',
    addressLabel: props.addressLabel ? props.addressLabel : '',
    deviceData: props.devices[props.currentPageId]
  }), /*#__PURE__*/_react.default.createElement(_StepComponent.default, (0, _extends2.default)({}, props.stepComponent, {
    currentStep: props.currentStep,
    stepLabels: generateStepLabels()
  }))), buildMeterView(props.devices[props.currentPageId], props.currentPageId)))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12 form-wrapper form-wrapper--has-shadow ano-meter-reading"
  }, /*#__PURE__*/_react.default.createElement(_MeterReadingGeneric.default, {
    genericTitle: props.genericTitle ? props.genericTitle : '',
    contractIdLabel: props.contractIdLabel ? props.contractIdLabel : '',
    addressLabel: props.addressLabel ? props.addressLabel : ''
  }), /*#__PURE__*/_react.default.createElement(_NoRegisterError.default, (0, _extends2.default)({}, props, {
    isSmallText: false
  }))));
};
function mapStateToProps(state) {
  return {
    devices: state.meterReading.devices,
    currentPageId: state.meterReading.currentPageId,
    currentStep: state.meterReading.currentStep,
    errorObjects: state.meterReading.errorObjects,
    errorHint: state.meterReading.errorHint,
    loading: state.meterReading.loading
  };
}
function mapDispatchToProps(dispatch) {
  return {
    loadMeterReadingData: function loadMeterReadingData(currentPage) {
      return (0, _meterReadingMainActions.loadCurrent)(dispatch, currentPage);
    },
    paginate: function paginate(currentPage) {
      return (0, _meterReadingMainActions.paginate)(dispatch, currentPage);
    },
    setCurrentStep: function setCurrentStep(currentStep) {
      return (0, _meterReadingMainActions.setCurrentStep)(dispatch, currentStep);
    },
    meterReadError: function meterReadError(errorObj) {
      return (0, _meterReadingMainActions.meterReadError)(dispatch, errorObj);
    }
  };
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MeterReadingPage);